import { Helmet } from 'react-helmet';
import './Start.css';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Start() {
  const navigate = useNavigate();

  useEffect(() => {
    const sendHeight = () => {
      const height = document.documentElement.scrollHeight;
      window.parent.postMessage({ type: 'setIframeHeight', height }, '*');
    };

    sendHeight();
    window.addEventListener('resize', sendHeight);

    return () => {
      window.removeEventListener('resize', sendHeight);
    };
  }, []);

  return (
    <div className="start-screen-background" style={{
      backgroundImage: "url('https://nagae.biz/tech-background-image.png')",
    }}>
      <div className="app-container">
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, viewport-fit=cover"
        />
        <Helmet>
          <link
            href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&display=swap"
            rel="stylesheet"
          />
        </Helmet>

        <header className="header">
          <div className="logo">
            <h1></h1>
            <p className="subtitle" style={{ marginBottom: '10px' }}></p>
          </div>
        </header>

        <main className="main-content"></main>
        <section id="start-screen" className="screen active">
        <div className="section-header">
          <h2 className="start-section-title" style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
            業務自動化可能性診断シミュレーション
          </h2>
          <div className="start-intro-text" style={{ maxWidth: '800px', margin: '0 auto 2rem auto', textAlign: 'center' }}>
            <p>このシミュレーションでは、業務の構造化レベルと人間の介入度を診断し、業務自動化の可能性を評価します。</p>
            <p>20の質問に回答することで、業務の特性を分析し、自動化の可能性とROI（投資対効果）を計算します。</p>
            <p>また、業務タイプに応じた具体的な改善提案も提供します。</p>
          </div>
        </div>
          <div className="card" style={{ transform: 'translateY(-60px)' }}>
            <div className="features">
              <div className="feature">
                <div className="feature-icon">📊</div>
                <div className="feature-text">
                  <h3>業務の構造化レベル診断</h3>
                  <p>業務の標準化・ルール化の進行度を測定</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon">👤</div>
                <div className="feature-text">
                  <h3>人間の介入度診断</h3>
                  <p>業務における人間の判断・操作・確認の必要性を評価</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon">💹</div>
                <div className="feature-text">
                  <h3>ROI計算</h3>
                  <p>業務自動化による時間短縮率と効果予測</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon">📝</div>
                <div className="feature-text">
                  <h3>改善提案</h3>
                  <p>診断結果に基づいた具体的な業務効率化提案</p>
                </div>
              </div>
            </div>

            <div
              style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1.5rem' }}
            >
              <button
                id="start-button"
                className="btn btn-primary"
                onClick={() => {
                  const isInIframe = window.self !== window.top;
                  if (isInIframe) {
                    window.open('/start', '_blank');
                  } else {
                    navigate('/start');
                  }
                }}
              >
                今すぐ無料で診断する
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Start;
